import React from 'react';

const List = (children) => {
    // const {children} = props;
    return (
        {children}
    );
}

export default List;